AppTabs.createTab( {
	name: 'units',
	icon: 'list-alt',
	text: 'Units',
	create: function(init) {
		'use strict'
	
		init.setDataTableArgs( {
	
			tableId: 		'#data-table-units',
	
			readTableName: 	'tblUnits',
			editTableName: 	'tblUnits',
			primaryKey: 	'UnitsID',
	
			hasColumnFilters: 	true,
			canSearch:          true,
			canSort:			true,
			paging:				false,
	
			actionData:			'datatable',
			actionAutofill: 	'datatable_autofill_units',
			actionCreate:		'datatable_create',
			actionEdit:			'datatable_edit',
			actionRemove:		'datatable_remove',
	
			editCallback:		function() {
				window.broadcastLocalStorageUpdateRequest( 'unitsOptions' );
			},
	
			fields: [
				{
					label: 		'Units',
					columnName: 'Units',
					isEditable: true,
					order: 		'asc',
				},
				{
					label: 		'EQUIS Report',
					columnName: 'Equis',
					isEditable: true,
				},
				{
					label: 		'Foremost UOM Qualifier',
					columnName: 'ForemostUOMQualifier',
					isEditable: true,
				},
				{
					label: 		'Frequent Use Flag',
					columnName: 'FrequentUseFlag',
					isEditable: true,
					type:		'boolean'
				},
			],
	
		} );
	}
	
	} );
	